import axios from "./axios";

class ProfileService {
  fetch = async () => {
    try {
      const response = await axios.post("/profile/fetch", {});

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };
}
export default new ProfileService();
